import React from 'react';
import { PropTypes } from 'prop-types';
import { NumberFormatter, Skeleton } from '@mantine/core';
import AppText from './AppText';
import AppFlexbox from './AppFlexbox';

const PriceRangeLineItem = ({
  label,
  fontSize,
  weight,
  color,
  loading,
  minPrice,
  maxPrice
}) => (
  <AppFlexbox
    style={{
      alignItems: 'center',
      justifyContent: 'space-between',
      gap: 8
    }}
  >
    <AppText
      style={{ fontSize: fontSize ?? 14, fontWeight: weight ?? 'normal' }}
    >
      {label}
    </AppText>
    {loading ? (
      <Skeleton height={20} width={90} />
    ) : (
      <AppText
        style={{
          fontSize: fontSize ?? 14,
          fontWeight: weight ?? 'normal',
          color: color ?? '#000'
        }}
      >
        <NumberFormatter
          decimalScale={2}
          fixedDecimalScale
          prefix="$"
          style={{ fontSize: fontSize ?? 14 }}
          thousandSeparator
          value={minPrice / 100}
        />
        {minPrice !== maxPrice && (
          <>
            {' '}
            -{' '}
            <NumberFormatter
              decimalScale={2}
              fixedDecimalScale
              prefix="$"
              style={{ fontSize: fontSize ?? 14 }}
              thousandSeparator
              value={maxPrice / 100}
            />
          </>
        )}
      </AppText>
    )}
  </AppFlexbox>
);

PriceRangeLineItem.propTypes = {
  color: PropTypes.string,
  fontSize: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  label: PropTypes.string,
  loading: PropTypes.bool,
  maxPrice: PropTypes.number,
  minPrice: PropTypes.number,
  weight: PropTypes.number
};

export default PriceRangeLineItem;
